import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { loadNewsSuccessAction } from '@app-modules/news/news-list/store/actions';

import { DpNewsService } from '../../../service/news.service';
import { NEWS_LIST_ACTIONS } from '../news-list-actions.type';

export const loadNewsListEffect = createEffect(
  (actions$ = inject(Actions), newsService = inject(DpNewsService)) =>
    actions$.pipe(
      ofType(NEWS_LIST_ACTIONS.LOAD_NEWS),
      switchMap(() => newsService.getAllNews().pipe(map(({ newsList }) => loadNewsSuccessAction({ newsList })))),
    ),
  { functional: true },
);
